<template>
  <div class="md:py-20 bg-blackly pt-12">
    <div class="container relative">
      <div class="md:flex-row flex flex-col items-center justify-between overflow-x-hidden">
        <div class="md:text-left md:w-4/12 w-full text-center">
          <div class="text-br-green md:mb-2 mb-5 fluid-xs leading-tightest capitalize">{{ tagLine }}</div>
          <h2 class="mr-auto fluid-3xl leading-tightest text-white">{{ heading }}</h2>
          <div v-if="body" class="text-copy md:my-2 my-5 leading-loose text-white" v-html="body"></div>
          <ArrowBtnNav
            class="md:absolute md:bottom-0 block my-6 text-white"
            :right-arrow-disabled="isLast"
            :left-arrow-disabled="isFirst"
            @onLeftClick="prevSlide"
            @onRightClick="nextSlide"
          />
        </div>
        <CardSlider
          v-if="experts.length"
          ref="featuredExpertsSlider"
          :breakpoints="breakpoints"
          :show-arrows="false"
          :fullwidth-slides="true"
          class="md:w-8/12 w-full md:overflow-x-hidden"
          @change="setActiveSlide"
        >
          <div
            v-for="expert in experts"
            :key="expert.id"
            class="group px-5 md:px-8 relative cursor-pointer"
            data-test-id="expert"
            @click="navigateTo({ path: $localeRootPath(expert.uri) })"
          >
            <FixedAspect :ratio="3 / 2">
              <CldnImg
                v-if="expert.image && expert.image[0]"
                :src="expert.image[0].url"
                :alt="expert.image[0].title"
                sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
                crop="fill"
                class="filter grayscale group-hover:filter-none"
              />
            </FixedAspect>
            <div class="text-br-green-light mt-4 fluid-xl leading-tight font-medium font-medium">
              {{ expert.title }}
            </div>
            <div class="mt-2 fluid-xs leading-tightest text-white">{{ expert.jobTitle }}</div>
          </div>
        </CardSlider>
      </div>
    </div>
  </div>
</template>
<script>
import ArrowBtnNav from '@/components/common/ArrowBtnNav';
import FixedAspect from '@/components/common/FixedAspect';
import CldnImg from '@/components/CldnImg';
import CardSlider from '@/components/common/CardSlider';

export default defineNuxtComponent({
  components: {
    CardSlider,
    FixedAspect,
    ArrowBtnNav,
    CldnImg,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    tagLine: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    experts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      state: {
        currentSlide: 0,
        isFirst: null,
        isLast: null,
      },
      breakpoints: [
        {
          minWindowWidth: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
        {
          minWindowWidth: 768,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      ],
    };
  },
  computed: {
    isFirst() {
      return this.state.isFirst;
    },
    isLast() {
      return this.state.isLast;
    },
  },
  methods: {
    setActiveSlide(state) {
      if (typeof state !== 'object' && !state) return;
      this.state = state;
    },
    prevSlide() {
      this.$refs.featuredExpertsSlider?.prev();
    },
    nextSlide() {
      this.$refs.featuredExpertsSlider?.next();
    },
  },
});
</script>
